import React, { useState, memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { SxProps, Theme } from "@mui/material/styles";
import classes from "./ConfirmModal.module.scss";
import DialogButton from "../../uikit/atoms/buttons/DialogButton";

interface ConfirmModalProps {
  title: string;
  message: string;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  onExec: () => void;
  onCancel: () => void;
}

const style: { [key: string]: SxProps<Theme> } = {
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: 320, // Apply 320px width for screen widths above 0px
      sm: 360, // Apply 360px width for screen widths above 600px
    },
    bgcolor: "background.paper",
    border: "none",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "20px 0",
  },
  iconImage: {
    color: "error.main",
    marginTop: 0.5,
  },
  title: {
    color: "error.main",
  },
  message: {
    marginTop: "20px",
    marginLeft: "20px",
    marginBottom: "20px",
  },
};

const ConfirmModal: React.FC<ConfirmModalProps> = memo((props) => {
  const { title, message, setIsShow, onExec, onCancel } = props;
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setIsShow(false);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
    >
      <Box sx={style.box}>
        <div className={classes.root}>
          <div className={classes.titleContainer}>
            <ErrorOutlineIcon sx={style.iconImage} />
            <Typography
              id="confirm-modal-title"
              sx={style.title}
              variant="h6"
              component="h2"
            >
              {title}
            </Typography>
          </div>
          <div className="module-spacer--extra-small" />
          <Typography id="confirm-modal-description" sx={style.message}>
            {message}
          </Typography>
          <div className="module-spacer--small" />
          <div className={classes.buttons}>
            <DialogButton label="削除する" onClick={onExec} mode="delete" />
            <DialogButton label="キャンセル" onClick={onCancel} mode="no" />
          </div>
        </div>
      </Box>
    </Modal>
  );
});

export default ConfirmModal;
